import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1f1c9ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "modal"
}
const _hoisted_5 = { class: "contenedor" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Generar Recibo de Ingreso", -1))
const _hoisted_7 = { class: "contenido" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Transferencia", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Cheque", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 2,
  class: "modal"
}
const _hoisted_13 = { class: "contenedor" }
const _hoisted_14 = { class: "contenido" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Teléfonos: ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Email: ")
const _hoisted_18 = {
  key: 3,
  class: "table table-hover"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", null, "Prestador"),
    /*#__PURE__*/_createElementVNode("th", null, "Entregado"),
    /*#__PURE__*/_createElementVNode("th", null, "Vence"),
    /*#__PURE__*/_createElementVNode("th", null, "NCF"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_20 = { class: "bold" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "bold" }
const _hoisted_23 = { class: "bold" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "bold der" }
const _hoisted_27 = { class: "bold der" }
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    ($data.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    ($data.showModalCobrar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("label", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalCobrarMethod())),
              for: "btn-modal"
            }, "X"),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("select", {
                  id: "metodo",
                  type: "metodo",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.viaPagar) = $event))
                }, _hoisted_10, 512), [
                  [_vModelSelect, $data.viaPagar]
                ])
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  id: "valorPagar",
                  type: "number",
                  step: "500",
                  min: "0",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.valorPagar) = $event)),
                  class: "form-control",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ajustPago()))
                }, null, 544), [
                  [_vModelText, $data.valorPagar]
                ])
              ]),
              _createElementVNode("button", {
                disabled: !$data.valorPagar || !$data.viaPagar,
                class: "btn btn-info",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($options.cobrar(this.selectedDoc)), ["prevent"]))
              }, " Recibir ", 8, _hoisted_11)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("header", null, _toDisplayString(this.selectedCliente[0].descripcion), 1),
            _createElementVNode("label", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (this.showModalMethod())),
              for: "btn-modal"
            }, "X"),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("p", null, _toDisplayString(this.selectedCliente[0].telefonos), 1),
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("p", null, _toDisplayString(this.selectedCliente[0].email), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!$data.cargando)
      ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.balances, (balance, index) => {
            return (_openBlock(), _createElementBlock("tbody", { key: index }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_20, _toDisplayString(index + 1), 1),
                _createElementVNode("td", {
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => (this.search(balance.descCliente)),
                  class: "bold"
                }, _toDisplayString(balance.descCliente), 9, _hoisted_21),
                _createElementVNode("td", _hoisted_22, _toDisplayString(balance.medico), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString($options.formatDate(balance.fechaEfectivo)), 1),
                _createElementVNode("td", {
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => ($options.difDate(balance.fechaEfectivo, balance.fechaEfectivo)),
                  class: "bold"
                }, _toDisplayString($options.newFormatDate(balance.fechaEfectivo)), 9, _hoisted_24),
                _createElementVNode("td", _hoisted_25, _toDisplayString(balance.literal + $options.formatNumber2(balance.ncf)), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString($options.formatNumber(balance.factura)), 1),
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (this.showModalCobrarMethod(balance)),
                    style: {"cursor":"pointer"},
                    class: "fas fa-dollar-sign"
                  }, null, 8, _hoisted_28)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}